<template>
  <div>
    <v-data-table :headers="headers" :items="skus" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t("skus") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <button
            type="button"
            class="btn btn-info px-4 py-2 ls1 mb-2 mr-1"
            @click="() => showEditSkuModal(null)"
            :disabled="isEditable"
          >
            {{ $t("datatable_new_item") }}
          </button>
          <button
            type="button"
            class="btn btn-info px-4 py-2 ls1 mb-2"
            :disabled="isEditable"
            @click="showImportModal()"
          >
            {{ $t("import") }}
          </button>
        </v-toolbar>
      </template>

      <template v-slot:item.label_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.transfer_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.bundle_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.qc_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.assemble_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.special_pack_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="() => showEditSkuModal(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="() => removeSkus(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <EditSku
      ref="editSku"
      :actionFunction="editSkus"
      :skuItem="skuItem"
      :carriers="carriers"
      :clientId="clientId"
      :receiving_type="receiving_type"
    ></EditSku>
    <ImportData
      ref="importData"
      :label="$t('sku')"
      :setData="setImportDataToDataTable"
      :customer="customer"
    >
    </ImportData>
  </div>
</template>

<script>
import EditSku from "@/own/components/fulfillment/asn/skuContainer/EditSku";
import ImportData from "@/own/components/fulfillment/asn/skuContainer/ImportData";
import Swal from "sweetalert2";
export default {
  name: "SkuDatatable",
  props: [
    "setSku",
    "skus",
    "skuItem",
    "carriers",
    "clientId",
    "customer",
    "isEditable",
    "receiving_type",
  ],
  components: { EditSku, ImportData },
  data: () => ({}),
  computed: {
    headers() {
      let headers = [
        { text: this.$t("sku_id"), value: "sku_id" },
        { text: this.$t("sku_barcode"), value: "sku_barcode" },
        { text: this.$t("batch_number"), value: "batch_number" },
        { text: this.$t("expected_quantity"), value: "expected_qty" },
        { text: this.$t("require_labeling"), value: "label_flag" },
        { text: this.$t("transfer_column"), value: "transfer_flag" },
        { text: this.$t("require_bundling"), value: "bundle_flag" },
        { text: this.$t("require_qc"), value: "qc_flag" },
        { text: this.$t("require_assembling"), value: "assemble_flag" },
        { text: this.$t("expire_date"), value: "exp_date" },
      ];
      if (this.receiving_type == "2" || this.receiving_type == "3") {
        headers.splice(3, 0, {
          text: this.$t("carton_number"),
          value: "carton_number",
        });
      } else {
        headers.splice(3, 0, {
          text: this.$t("sku_carton_number"),
          value: "carton_number",
        });
      }
      if (!this.isEditable) {
        headers.push({
          text: this.$t("actions"),
          value: "actions",
          sortable: false,
        });
      }
      return headers;
    },
  },
  methods: {
    showImportModal() {
      this.$refs.importData.toggleModal();
    },
    setImportDataToDataTable(importedData) {
      this.setSku([]);
      this.setSku(importedData);
    },
    showEditSkuModal(item) {
      if (this.isEditable) {
        return;
      }
      if (!this.customer && !this.clientId) {
        Swal.fire({
          title: "",
          text: this.$t("select_customer_for_skus"),
          icon: "warning",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      this.$refs.editSku.toggleModal(item);
    },

    editSkus(item, editItem) {
      if (editItem) {
        this.removeSkus(editItem);
      }
      this.$nextTick(() => {
        let new_skus = [...this.skus];
        let copy = new_skus.findIndex(
          (sku) => sku.sku_barcode == item.sku_barcode
        );
        if (copy > -1) {
          if (
            new_skus[copy].batch_number === item.batch_number &&
            new_skus[copy].transfer_flag === item.transfer_flag
          ) {
            if (
              this.receiving_type > 1 &&
              new_skus[copy].carton_number === item.carton_number
            ) {
              new_skus[copy].expected_qty =
                parseInt(new_skus[copy].expected_qty) +
                parseInt(item.expected_qty);
            } else if (
              this.receiving_type === 1 &&
              new_skus[copy].sku_carton_number === item.sku_carton_number
            ) {
              new_skus[copy].expected_qty =
                parseInt(new_skus[copy].expected_qty) +
                parseInt(item.expected_qty);
            } else new_skus.push(item);
          } else {
            Swal.fire({
              title: this.$t("warning"),
              text: this.$t("sku_duplicate_barcode"),
              icon: "warning",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          }
        } else {
          new_skus.push(item);
        }
        this.setSku(new_skus);
      });
    },
    removeSkus(item) {
      if (this.isEditable) {
        return;
      }
      let new_skus = [...this.skus];
      const index = new_skus.findIndex(
        (sku) =>
          sku.sku_id === item.sku_id && sku.sku_barcode === item.sku_barcode
      );

      new_skus.splice(index, 1);
      this.setSku(new_skus);
    },
  },
};
</script>
